
var lat = 48.028900;
var lon = -0.627803;
var prev_infowindow = false;

function initMap() {
    var myLatLng = {lat: lat, lng: lon};

    var map = new google.maps.Map(document.getElementById('visitemap'), {
      zoom: 17,
      center: myLatLng,
      mapTypeId: 'satellite'
    });
    for (pin in pins) {
        console.log({lat: pins[pin].lat, lng: pins[pin].lon});
        var marker = new google.maps.Marker({
            position: {lat: parseFloat(pins[pin].lat), lng: parseFloat(pins[pin].lon)},
            map: map
        });

        var infowindow = new google.maps.InfoWindow();

        google.maps.event.addListener(marker,'click', (function(marker,content,infowindow,pin){
            return function() {
                infowindow.setContent($("#js-visitebox-" + pin).html());
                if( prev_infowindow ) {
                    prev_infowindow.close();
                }
                prev_infowindow = infowindow;
                infowindow.open(map,marker);
            };
        })(marker,content,infowindow,pin));

    }
    google.maps.event.addListener(map, "click", function(event) {
        if( prev_infowindow ) {
            prev_infowindow.close();
        }
    });
  }